import { Portal } from '@components/Portal'
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { Container, OverlayContainer } from './sheet.styled'

interface Props {
  children: ({ close }: { close: (onClose: () => void) => void }) => React.ReactNode
  onClose: () => void
}

export const Sheet = (props: Props): JSX.Element => {
  const { children, onClose } = props
  const refOverlayContainer = useRef<HTMLDivElement | null>(null)
  const refChildrenContainer = useRef<HTMLDivElement | null>(null)
  const [display, setDisplay] = useState<boolean>(false)
  const [displayChildren, setDisplayChildren] = useState<boolean>(false)
  const [heights, setHeights] = useState({ overlay: window.innerHeight, children: 0 })

  const updateHeights = () => {
    setHeights({
      overlay: refOverlayContainer.current?.clientHeight || 0,
      children: refChildrenContainer.current?.clientHeight || 0,
    })
  }

  useEffect(() => {
    setTimeout(() => {
      setDisplayChildren(true)
    }, 25)
    setTimeout(() => {
      setDisplay(true)
    }, 50)
  }, [])

  useLayoutEffect(() => {
    const resizeObserver = new ResizeObserver(updateHeights)
    if (refChildrenContainer.current) {
      resizeObserver.observe(refChildrenContainer.current)
    }
    return () => resizeObserver.disconnect()
  }, [displayChildren])

  return (
    <Portal
      style={{
        top: 0,
        left: 0,
        zIndex: 10000000,
      }}
    >
      <OverlayContainer
        ref={(ref) => (refOverlayContainer.current = ref)}
        open={display}
        onClick={() => {
          setDisplay(false)
          setTimeout(() => {
            onClose()
          }, 150)
        }}
      />
      {displayChildren && (
        <Container
          ref={(ref) => (refChildrenContainer.current = ref)}
          heightOverlay={heights.overlay}
          heightChildren={heights.children}
          open={display}
        >
          {children({
            close: (onClose) => {
              setDisplay(false)
              setTimeout(() => {
                onClose()
              }, 150)
            },
          })}
        </Container>
      )}
    </Portal>
  )
}
